<template>
    <div>
        <el-form-item :label="$t('shared.allowedDistance')">
            <el-input type="number" v-model="allowedDistance"></el-input>
        </el-form-item>
        <div v-on:click="getServiceCompanies();">
            <el-form-item :label="$t('common.serviceCompany')" prop="primaryServiceCompanyId">
                <el-select name="serviceCompanySelector" :value="value" class="select" clearable :placeholder="$t('shared.pleaseSelectServiceCompany')" :loading="loading" @change="$emit('input', $event)" :no-data-text="$t('shared.noCompaniesInCurrentProvince')">
                    <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </div>
    </div>
</template>

<script>
    import api from "./api";

    export default {
        name: "company-selector",
        props: [
            "value",
            "country",
            "state",
            "city",
            "address",
            "zip",
            "serviceCompany",
            "previousState"
        ],
        data() {
            return {
                loading: false,
                companies: [],
                allowedDistance: null,
                formState: {
                    country: undefined,
                    state: undefined,
                    city: undefined,
                    address: undefined,
                    zip: undefined,
                    serviceCompany: undefined,
                    distance: null,
                    lastId: undefined
                }
            };
        },
        watch: {
            country: function (val) {
                this.value= "";
                this.companies = [];
            },
            state: function (val) {
                this.value= "";
                this.companies = [];
            },
            city: function (val) {
                this.value= "";
                this.companies = [];
            },
            address: function (val) {
                this.value= "";
                this.companies = [];
            },
            zip: function (val) {
                this.value= "";
                this.companies = [];
            },
            value: function (val) {
                if (+val && typeof (+val) === "number") {
                    this.formState.lastId = val;
                    this.$emit('update:serviceCompany', this.value)
                }
            },
            serviceCompany: function (val) {
            },
            allowedDistance: function (val) {
                this.value= "";
                this.companies = [];
            },
            previousState: function (val) {

            }
        },
        mounted: function () {
            this.allowedDistance = null;
        },
        methods: {
            getServiceCompanies() {
                if (this.value=== undefined || (!this.formState.country && !this.formState.state && !this.formState.city && !this.formState.address && !this.formState.zip && !this.formState.serviceCompany)) {
                    this.resetFields();
                    this.searchCompanies();
                }
                else {
                    if (this.formState.country !== this.country) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                    else if (this.formState.state !== this.state) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                    else if (this.formState.city !== this.city) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                    else if (this.formState.address !== this.address) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                    else if (this.formState.zip !== this.zip) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                    else if (this.formState.serviceCompany !== this.serviceCompany) {
                        this.formState.serviceCompany = this.serviceCompany;
                    }
                    else if (this.formState.distance !== this.allowedDistance) {
                        this.resetFields();
                        this.searchCompanies();
                    }
                }
            },
            resetFields() {
                this.formState.country = this.country ? this.country.toString() : undefined;
                this.formState.state = this.state ? this.state.toString() : undefined;
                this.formState.city = this.city ? this.city.toString() : undefined;
                this.formState.address = this.address ? this.address.toString() : undefined;
                this.formState.zip = this.zip ? this.zip.toString() : undefined;
                this.formState.serviceCompany = this.serviceCompany ? this.serviceCompany.toString() : undefined;
                this.formState.distance = this.allowedDistance ? this.allowedDistance.toString() : null;
            },
            cleanFields() {
                this.formState.country = undefined;
                this.formState.state = undefined;
                this.formState.city = undefined;
                this.formState.address = undefined;
                this.formState.zip = undefined;
                this.formState.serviceCompany = undefined;
                this.formState.distance = null;
            },
            searchCompanies() {
                var self = this;
                if (!this.country || !this.state) {
                    alert(this.$t('common.pleaseChooseCountryAndProvince'));
                    return;
                }
                self.loading = true;
                api
                    .getServiceCompanyList(
                        this.country,
                        this.state,
                        this.city,
                        this.address,
                        this.zip,
                        this.serviceCompany,
                        this.allowedDistance
                    )
                    .then(function (response) {
                        self.loading = false;
                        self.companies = response.data;
                        console.log(self.companies);
                    })
                    .catch(function () {
                        self.loading = false;
                        self.companies = [];
                    });
            }
        }
    };
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/companyselector/CompanySelector.vue